import { Popup } from 'react-leaflet';

import { NodeType } from '../../../schema/Node.ts';
import { CreateMissionFromNode } from '../../Dashboard/Map/CreateMissionFromNode.tsx';

export function SimplePopup({ node }: Readonly<{ node: NodeType }>) {
  return (
    <Popup>
      <div>
        <p className="card-text">{node.name}</p>
        <p className="mb-3">ID: {node.id}</p>
        <CreateMissionFromNode node={node} />
      </div>
    </Popup>
  );
}
